import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Property } from "@/types/property";
import PropertyRow from "@/components/v2/molecules/admin/tabs/AdminPropertiesTab/PropertyRow";

interface PropertiesTableProps {
  properties: Property[];
  onEdit: (property: Property) => void;
  canDelete: boolean;
}

const PropertiesTable = ({ properties, onEdit, canDelete }: PropertiesTableProps) => {
  const tableHeaders = [
    "Nombre corto",
    "Inicio de Operación",
    "Título",
    "Estatus",
    "Destacada",
    "Precio x Noche",
    "Características",
    "Ubicación",
    "Acciones",
  ];

  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableHead key={header}>{header}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {properties.length === 0 ? (
            <TableRow>
              <TableCell colSpan={9} className="text-center py-8 text-muted-foreground">
                No se encontraron propiedades
              </TableCell>
            </TableRow>
          ) : (
            properties.map((property) => (
              <PropertyRow
                key={property.id}
                property={property}
                onEdit={onEdit}
                canDelete={canDelete}
              />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default PropertiesTable;